export class MeetTheTeam extends DrupalBehavior {
  onContent(context) {
    const meetTheTeam = context.querySelector('.meet-the-team');
    if (meetTheTeam) {
      const items = context.querySelectorAll('.meet-the-team--item');

      items.forEach((item) => {
        const showMore = item.querySelector('.meet-the-team--item--show');
        const hidden = item.querySelector('.meet-the-team--item--hidden');
        if (hidden) {
          showMore.addEventListener(
            'click',
            () => {
              if (showMore.getAttribute('aria-expanded') == 'false') {
                hidden.classList.add('visible');
                showMore.setAttribute('aria-expanded', true);
                showMore.classList.add('hidden');
                showMore.textContent = 'Show Fewer Locations';
              } else {
                hidden.classList.remove('visible');
                showMore.setAttribute('aria-expanded', false);
                showMore.classList.remove('hidden');
                showMore.textContent = 'Show More Locations';
              }
            },
            true
          );
        }
      });
    }
  }
}
DrupalBehavior.register('rush_theme.components', 'meet_the_team', MeetTheTeam);
